import React from 'react'
import { cn } from '@/lib/utils'

/** Fast (0.7s) spinner — perceived load time drops with spin speed. */
const Spinner = ({ className }: { className?: string }) => (
  <svg
    className={cn('size-4 animate-spin [animation-duration:700ms]', className)}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
  >
    <circle cx="8" cy="8" r="6" stroke="currentColor" strokeOpacity="0.25" strokeWidth="1.5" />
    <path
      d="M14 8a6 6 0 0 0-6-6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default Spinner
